import request from '../../../axios';

export const getMessagesChats = async (pageNumber: number, guid?: string) => {
  const {data}: {data: IMessagesChats} = await request.get(
    `/api/v2/shop/chat/${guid}/messages?page=` + pageNumber,
  );
  return data;
};
